import React, { useMemo } from 'react';
import { orderBy, sum } from 'lodash';

import BarChart from '../../../charts/BarChart';

import { formatChartPrice } from '../../../../utils/utils';

export const CustomTooltip = (props) => {
  const { data, value } = props;

  return (
    <div className="custom-tooltip">
      <div className="tooltip-label">{data.id}</div>
      <div className="tooltip-content">
        <div>{`$${formatChartPrice(value, 0)}`}</div>
      </div>
    </div>
  );
};


const BillingStatesProformaBarChart = ({ cases = [], hospitals = [] }) => {
  const data = useMemo(() => {
    const states = [];

    hospitals?.forEach((hospital) => {
      if (!states?.includes(hospital.state)) {
        states.push(hospital.state);
      }
    });

    const allHospitals = states
      .map((state) => {
        const stateCases = cases.filter((item) => {
          const hospital = hospitals?.find((h) => item.hospital === h.id);
          return hospital.state === state;
        });
        const value = sum(stateCases?.map((caseItem) => caseItem.proformaValue || 0));

        return {
          id: state,
          label: state,
          value,
        };
      })
      .filter((item) => item.value !== 0);

    const sorted = orderBy(allHospitals, 'value', 'desc');
    const top10 = sorted.splice(0, 10);

    return top10;
  }, [cases, hospitals]);

  return (
    <div className="management-reports-chart__container m-r-md" style={{ width: '50%' }}>
      <div className="font-size-bg font-bold">Top States by Total Value</div>
      <div className="secondary m-t-sm m-b-lg">Top 10 states by proforma value for completed cases</div>
      <BarChart
        data={data || []}
        indexBy="id"
        height="300px"
        layout="horizontal"
        enableLabel={true}
        margin={{ top: 10, right: 25, bottom: 30, left: 80 }}
        axisLeft={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          truncateTickAt: 0,
          format: (name) => name ? `${name?.substring(0, 10)}${name?.length > 10 ? '...' : ''}` : ''
        }}
        labelTextColor={{
          from: 'color',
          modifiers: [
            [
              'darker',
              1.6,
            ],
          ],
        }}
        label={(d) => `$${formatChartPrice(d.value, 0)}`}
        CustomTooltip={CustomTooltip}
      />
    </div>
  );
};

export default BillingStatesProformaBarChart;
